import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GenericDropdownModule } from 'app/shared/generic-dropdown/generic-dropdown.module';
import { SiteDropdownComponent } from './site-dropdown.component';

@NgModule({
	declarations: [SiteDropdownComponent],
	exports: [SiteDropdownComponent],
	imports: [CommonModule, GenericDropdownModule, FormsModule]
})
export class SiteDropdownModule {}
